// IMPORTANT: Build gql after ANY changes to queries (client OR api)
import { graphql } from '@/client/services/api/graphql/gql/gql';

export const searchSegmentationsQuery: any = graphql(`
  query ListSegmentations(
    $includeTotalCount: Boolean! = false
    $name: StringQueryOperatorArgs
    $page: Int! = 0
    $pageSize: Int! = 50
  ) {
    segmentations(
      includeTotalCount: $includeTotalCount
      name: $name
      page: $page
      pageSize: $pageSize
    ) {
      edges {
        node {
          __typename
          id
          name
          segmentationType
        }
      }
    }
  }
`);
